var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgIcArrowRight(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 17,
    height: 17,
    viewBox: "0 0 17 17",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M8.73429 3.13434C9.04671 2.82192 9.55324 2.82192 9.86566 3.13434L14.6657 7.93434C14.9781 8.24676 14.9781 8.75329 14.6657 9.06571L9.86566 13.8657C9.55324 14.1781 9.04671 14.1781 8.73429 13.8657C8.42187 13.5533 8.42187 13.0468 8.73429 12.7343L12.1686 9.30002L2.89998 9.30003C2.45815 9.30002 2.09998 8.94185 2.09998 8.50002C2.09998 8.0582 2.45815 7.70002 2.89998 7.70002H12.1686L8.73429 4.26571C8.42187 3.95329 8.42187 3.44676 8.73429 3.13434Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIcArrowRight);
export default __webpack_public_path__ + "static/media/ic-arrow-right.bf808e2b928c6c7af3c43f734f212994.svg";
export { ForwardRef as ReactComponent };